var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"hidden-input",attrs:{"tabindex":"-1","data-external":"signup-verify-user-hidden-input"}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }